import { render } from "./NotesSec.vue?vue&type=template&id=2b750a5f&scoped=true"
import script from "./NotesSec.vue?vue&type=script&lang=js"
export * from "./NotesSec.vue?vue&type=script&lang=js"

import "./NotesSec.vue?vue&type=style&index=0&id=2b750a5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b750a5f"]])

export default __exports__